import { Attribute, Component, Input, OnInit } from '@angular/core';
import { AttributeService } from '@product/shared/services/attribute-service.service';

@Component({
  selector: 'app-attribute-sets',
  templateUrl: './attribute-sets.component.html',
  styleUrls: ['./attribute-sets.component.less']
})
export class AttributeSetsComponent implements OnInit {
  //attributes: CustomAttribute[] = []; 

  //@Input() attributeSetId:number=0;

  attributes: any[] = []; 
  constructor(private attributeService: AttributeService) { }

  ngOnInit() {
    const attributeSetId = 2; 
 
    
    this.attributeService.getAttributesBySetId(attributeSetId).subscribe(
      {
       next:(response)=>{
         this.attributes = response.value;
         
       },
       error:(error)=>{
         console.error('Error get attributes:', error); 
       }
      }
     );
  }

 getAttributesBySetId(attributeSetId: number): void {
   
  }
}
 